/**
 * Inbound filters. Custom Release and Error Message filtering.
 */
export const ignoreErrors: Array<string> = [
  'ChunkLoadError',
  'Loading chunk',
  'Loading CSS chunk'
];
